import { ModelDef } from '../../../common/$models/ModelDef'

const model: ModelDef = {
  tableName: 'record_workflow_thread_item_related_users',
  tableLabel: 'ワークフローアイテム関連ユーザー',
  primaryKeyColType: 'UUID',
  columns: {
    id: {
      type: 'UUID',
      label: 'ID',
    },
    threadItem: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: 'ワークフローアイテム',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'record_workflow_thread_items',
        labelFormatter: (record) => `${record.nodeKey} - ${record.nodeState}`,
        onDeleteDbRestriction: 'CASCADE',
      },
    },
    user: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: 'ユーザー',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'directus_users',
        labelFormatter: (record) => `${record.first_name} (${record.email})`,
      },
    },
    type: {
      type: 'SELECT',
      label: '種別',
      validate: { notEmpty: true },
      selections: () => [
        { value: 'upcoming', label: '予定' },
        { value: 'executed', label: '実行済み' },
      ],
      defaultValue: 'upcoming',
    },
    // role: {
    //   type: 'STRING',
    //   label: '役割',
    //   validate: { notEmpty: true },
    // },
    // order: {
    //   type: 'NUMBER',
    //   label: '承認順序',
    //   defaultValue: 0,
    // },
    // required: {
    //   type: 'BOOLEAN',
    //   label: '必須承認者',
    //   defaultValue: true,
    // },
    // status: {
    //   type: 'SELECT',
    //   label: '承認状態',
    //   selections: () => [
    //     { value: 'pending', label: '保留中' },
    //     { value: 'approved', label: '承認済み' },
    //     { value: 'rejected', label: '却下' },
    //     { value: 'skipped', label: 'スキップ' },
    //   ],
    //   defaultValue: 'pending',
    // },
    dueDate: {
      type: 'DATETIME',
      label: '承認期限日時',
    },
    executedAt: {
      type: 'DATETIME',
      label: '実行日時',
    },
    comment: {
      type: 'TEXT',
      label: 'コメント',
    },
    metadata: {
      type: 'JSON',
      label: 'メタデータ',
      comment: '追加情報（承認条件、スキップ理由など）',
    },
  },
  formColumnGroups: {
    basic: {
      type: 'tab',
      label: '基本情報',
      order: 10,
    },
    meta: {
      type: 'tab',
      label: 'メタデータ',
      order: 20,
    },
  },
}

export const record_workflow_thread_item_related_users = model

export type ModelRecordWorkflowThreadItemRelatedUsers = {
  id: string
  threadItem: string
  user: string
  type: 'upcoming' | 'executed'
  role: string
  order: number
  required: boolean
  status: 'pending' | 'approved' | 'rejected' | 'skipped'
  dueDate?: string
  executedAt?: string
  comment?: string
  metadata?: Record<string, unknown>
}
